import { FC, useEffect } from 'react';
import NextHead from 'next/head';
import { useSiteInfo } from '~/pages/_shared';

export const Head: FC = () => {
   const { data: siteInfo } = useSiteInfo();
   const customCss = siteInfo?.['appearance-css'];
   const printCss = '@media print { body { display:none } }';
   const allowWebPrinting = siteInfo?.['allow-web-printing'];
   const fontCss =
      'body { font-family: Inter, -apple-system, Segoe UI, Helvetica, Arial, sans-serif; }';

   useEffect(() => {
      let style = document.createElement('style');
      style.appendChild(document.createTextNode(fontCss));
      document.head.appendChild(style);
   }, []);

   return (
      <NextHead>
         <>
            {customCss && (
               <style
                  id="customCss"
                  type="text/css"
                  dangerouslySetInnerHTML={{ __html: customCss }}
               />
            )}
            {!allowWebPrinting && (
               <style
                  id="allowWebPrinting"
                  type="text/css"
                  dangerouslySetInnerHTML={{ __html: printCss }}
               />
            )}
         </>
      </NextHead>
   );
};
